export default __webpack_public_path__ + "static/logo-wide-7fd7e3e8b147a6fdce40e0b5c6b3ef0e.png";